import YOLA_GET_WEBSITE_DETAILS from '@/graphql/GET_YOLA_WEBSITE_DETAILS.gql'
import YOLA_GET_WEBSITE_SSO_URL from '@/graphql/GET_YOLA_WEBSITE_SSO_URL.gql'
import { mapState } from 'vuex'

const generatedYolaUrlMixin = {
  computed: {
    ...mapState(['services'])
  },
  data () {
    return {
      errors: null
    }
  },
  apollo: {
    yolaWebsiteDetails: {
      skip () {
        return Boolean(!this.services.yolawebsite)
      },
      query: YOLA_GET_WEBSITE_DETAILS,
      variables () {
        return { yolaWebsiteId: this.services.yolawebsite }
      },
      update: data => data.yolaWebsiteDetailsGet,
      error (error) {
        this.errors = JSON.stringify(error.message)
      }
    }
  },
  methods: {
    async goToYolaGeneratedLink (linkFn, evt) {
      let newtab, link
      if (evt) {
        // If we include an event, grab the innertext
        // of the target to display 'loading' text
        const innerText = evt.target.innerText
        evt.target.innerText = 'Loading...'
        try {
          link = await linkFn()
          newtab = window.open()
          newtab.location = link
        } catch (err) {
          console.error(err)
        } finally {
          evt.target.innerText = innerText
        }
      } else {
        // If no event is included, open a new tab
        // immediately. Better when from the sidebar
        newtab = window.open()
        link = await linkFn()
        newtab.location = link
      }
    },

    async getYolaWebsiteEditLink () {
      try {
        const { data } = await this.$apollo.query({
          query: YOLA_GET_WEBSITE_SSO_URL,
          variables: {
            yolaWebsiteId: this.services.yolawebsite,
            destination: 'Editor'
          },
          fetchPolicy: 'network-only'
        })
        return data.yolaWebsiteSsoUrlGet
      } catch (err) {
        return err
      }
    }
  }
}

export default generatedYolaUrlMixin
